"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextTask = exports.removeFinishTrigger = exports.addFinishTrigger = exports.errorQueue = exports.removeTask = exports.addTask = exports.getCartState = exports.FINISH_TRIGGERS = exports.CART_QUEUE = void 0;
var jquery_1 = require("../jquery");
var events_1 = require("./events");
var get_1 = require("./get");
//Constants
exports.CART_QUEUE = [];
exports.FINISH_TRIGGERS = [];
;
//Task Management
var getCartState = function () {
    return exports.CART_QUEUE.length ? 'pending' : 'finished';
};
exports.getCartState = getCartState;
/** @deprecated */
var addTask = function (task) {
    exports.CART_QUEUE.push(task);
    if (exports.CART_QUEUE.length === 1) {
        //First task
        (0, jquery_1.jq)(document).trigger(events_1.ON_CART_PENDING);
        (0, exports.nextTask)();
    }
};
exports.addTask = addTask;
/** @deprecated */
var removeTask = function (task) {
    var action = task.action;
    var i = exports.CART_QUEUE.indexOf(task);
    //This will be called every time a task finished OR fails, if the final task
    //is not a GET cart, then we're going to do a get cart
    var isLast = exports.CART_QUEUE.length === 1;
    if (isLast && !(action == 'get' || action == 'details' || action == 'clear'))
        (0, get_1.getCartCB)(); //This will add a get cart task
    if (i !== -1)
        return exports.CART_QUEUE.splice(i, 1);
    (0, exports.nextTask)();
};
exports.removeTask = removeTask;
/** @deprecated */
var errorQueue = function () {
    var queue = __spreadArray([], exports.CART_QUEUE, true);
    exports.CART_QUEUE.splice(0, exports.CART_QUEUE.length);
    queue.forEach(function (e) {
        if (!e.errorCallback)
            return;
        e.errorCallback("Another task failed");
        (0, exports.removeTask)(e);
    });
    (0, jquery_1.jq)(document).trigger(events_1.ON_CART_FINISHED);
};
exports.errorQueue = errorQueue;
//Trigger Management
/** @deprecated */
var addFinishTrigger = function (trigger) {
    if (exports.FINISH_TRIGGERS.indexOf(trigger) !== -1)
        return;
    exports.FINISH_TRIGGERS.push(trigger);
};
exports.addFinishTrigger = addFinishTrigger;
/** @deprecated */
var removeFinishTrigger = function (trigger) {
    var i = exports.FINISH_TRIGGERS.indexOf(trigger);
    if (i === -1)
        return;
    exports.FINISH_TRIGGERS.splice(i, 1);
};
exports.removeFinishTrigger = removeFinishTrigger;
//Queue Management
/** @deprecated */
var nextTask = function () {
    //Is the task list finished?
    if (!exports.CART_QUEUE.length) {
        __spreadArray([], exports.FINISH_TRIGGERS, true).forEach(function (trigger) {
            (0, jquery_1.jq)(document).trigger(trigger.event, trigger.data);
            (0, exports.removeFinishTrigger)(trigger);
        });
        (0, jquery_1.jq)(document).trigger(events_1.ON_CART_FINISHED);
        return;
    }
    //Fetch the next task
    var task = exports.CART_QUEUE[0];
    task.task();
};
exports.nextTask = nextTask;
//# sourceMappingURL=queue.js.map